import { render } from "./segmentedControlComponent.vue?vue&type=template&id=80355ac6&ts=true"
import script from "./segmentedControlComponent?vue&type=script&lang=ts"
export * from "./segmentedControlComponent?vue&type=script&lang=ts"

import "./_assets/_segmented-control.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__